<template>
  <div id="documents-page-wrapper" class="documents">
    <c-switcher
      v-if="isUserAllowedToDocumentsAndMedicalAnalyses"
      v-model="switcherLocal"
      class="finance__switcher h-switcher"
      type="group"
      :items="[
        { label: 'Общие документы', value: 'acting_documents' },
        { label: 'Мед.книжка', value: 'medical_documents' },
      ]"
    />

    <main-documents v-if="mainDocumentsSelected" />
    <medical-documents v-if="medicalDocumentsSelected" />

    <to-top-button element=".layout" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Switcher from "@/components/controls2/Switcher";
import MainDocuments from "./main-documents";
import MedicalDocuments from "./medical-documents";
import { userPermissionsList } from "@/constants/userPermissions";
import ToTopButton from "../../../components/to-top-button";

export default {
  name: "index",
  components: {
    ToTopButton,
    MainDocuments,
    MedicalDocuments,
    "c-switcher": Switcher,
  },
  data() {
    return {
      switcherLocal: this.$route.query.tab ? this.$route.query.tab : "acting_documents",
    };
  },
  computed: {
    ...mapGetters(["getUserPermissions"]),
    mainDocumentsSelected() {
      return this.switcherLocal === "acting_documents";
    },
    medicalDocumentsSelected() {
      return this.switcherLocal === "medical_documents";
    },
    isUserAllowedToDocumentsAndMedicalAnalyses() {
      return (
        this.getUserPermissions.includes(userPermissionsList.worker.medicalAnalyses.view) &&
        this.getUserPermissions.includes(userPermissionsList.worker.documents.view)
      );
    },
  },
  watch: {
    switcherLocal() {
      this.$router.replace({
        name: "personal-employee-documents",
        query: {
          tab: this.switcherLocal,
        },
      });
    },
  },
};
</script>

<style scoped>
.documents {
  margin-top: 35px;
}
</style>
